import axiosInstance from "auth/FetchInterceptor";
import {
  SUPPLIER_PRICE_LIST,
  SUPPLIER_PRICE_UPSERT,
  SUPPLIER_PRICE_ADD,
  SUPPLIER_PRICE_HISTORY,
  SUPPLIER_PRICE_HISTORY_BY_SUPPLIER,
  SUPPLIER_PRICE_DELETE,
  SUPPLIER_PRICE_LOOKUP,
  SUPPLIER,
  SUPPLIER_EXPORT,
} from "constants/ApiConstant";

const SupplierPriceService = {};

SupplierPriceService.getSupplierPrices = function (data) {
  return axiosInstance.post(SUPPLIER_PRICE_LIST, data);
};

SupplierPriceService.upsertSupplierPrices = function (data) {
  return axiosInstance.post(SUPPLIER_PRICE_UPSERT, data);
};

SupplierPriceService.addSupplierPrices = function (data) {
  return axiosInstance.post(SUPPLIER_PRICE_ADD, data);
};

SupplierPriceService.getPriceHistory = function (id) {
  return axiosInstance.get(`${SUPPLIER_PRICE_HISTORY}/${id}`);
};

SupplierPriceService.getHistoryBySupplier = function (data) {
  return axiosInstance.post(SUPPLIER_PRICE_HISTORY_BY_SUPPLIER, data);
};

SupplierPriceService.deleteSupplierPrice = function (id) {
  return axiosInstance.delete(`${SUPPLIER_PRICE_DELETE}/${id}`, null);
};

SupplierPriceService.lookupPrices = function (data) {
  return axiosInstance.post(SUPPLIER_PRICE_LOOKUP, data);
};

SupplierPriceService.getSuppliers = function (data) {
  return axiosInstance.post(SUPPLIER, data);
};

SupplierPriceService.exportSuppliers = function (data) {
  return axiosInstance.post(SUPPLIER_EXPORT, data, {
    responseType: "blob",
  });
};

export default SupplierPriceService;